const queryParams = ({
  pageId,
  currentProvider,
  deal: {
    id,
    productId,
    title: dealTitle,
    provider: { name }
  },
  ecommerce: { impressionId, comparisonId },
  list,
  page,
  placementType,
  position,
  postcode,
  sort,
  sskey,
  title
}) => ({
  cid: comparisonId || '',
  current_provider: currentProvider || '',
  deal: id,
  did: id,
  lid: pageId,
  llid: comparisonId,
  iid: impressionId || '',
  list,
  page,
  placement: ['table', 'carousel'].includes(placementType) ? placementType : 'ad',
  position,
  postcode: postcode || '',
  product_id: productId,
  pid: productId,
  product_name: title || dealTitle,
  sort,
  supplier: name,
  sskey
})

export const clickOutLink = ({ deal }) => {
  const clickoutLink = deal.clickoutLinks.find(({ type }) => type === 'CLICKOUT')
  const personalisedLink = deal.clickoutLinks.find(({ type }) => type === 'PERSONALISED')

  return personalisedLink || clickoutLink // return sharedJourney if it exists
}

export const clickoutUrl = (args) => {
  const link = clickOutLink(args)
  const params = queryParams(args)

  const queryString = Object.keys(params)
    .map((param) => `${param}=${encodeURIComponent(params[param])}`)
    .join('&')

  return `${link.url}&${queryString}`
}

export default { clickoutUrl, clickOutLink }
